module.exports = __webpack_public_path__ + "static/media/azteca.4af05234.png";